import http from '@/http'
const URL = '/admin/admin-users'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveUser = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}
export const savePass = (payload) => http.put(URL + `/${payload.id}/password`, payload)
export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export const deleteUser = async (id) => http.delete(URL + `/${id}`)

export const getRoles = async () => http.get(URL + '/roles')

export const getPermissions = async () => http.get(URL + '/permissions')

export const updatePermissions = (userId, permissions) => http.put(URL + `/${userId}/permissions`, { permissions })

export const bulkCreate = (payload) => http.post(URL + '/bulk-create', payload)

// Lista todas as tags do evento — usado pelo multiselect "Tags Permitidas"
// no form de criação/edição de admin user. Não é o endpoint filtrado do
// check-in; aqui o admin SEMPRE precisa ver todas pra escolher.
export const getTagsForUserForm = async () => http.get('/admin/tags', { params: { limit: 1000 } })

export default {
  list,
  show,
  saveUser,
  savePass,
  changeStatus,
  deleteUser,
  getRoles,
  getPermissions,
  updatePermissions,
  bulkCreate,
  getTagsForUserForm
}
